import {z} from '@hono/zod-openapi';

export const priceReportArgumentCategorySchema = z
  .enum([
    'price',
    'market_speed',
    'supply',
    'mileage',
    'equipment',
    'price_trend',
    'costs',
    'vehicle',
  ])
  .openapi('PriceReportArgumentCategory');

export type PriceReportArgumentCategory = z.infer<typeof priceReportArgumentCategorySchema>;
